import { Getter, lazyLoad } from '@if/core/utils'

export const PRESENCE_VACATION = -1 as const
export const PRESENCE_UNDEFINED = -2 as const
export const WEEK_PRESENCE_REQUIRED = 4 as const

export type WeeklyPresencesListDto = Record<string, Record<string, number>[]>

export interface WeekPresencesCountDto {
  startOfWeekDate: string
  presencesCount: number
}

export interface PersonWeeklyPresencesDto {
  personId: string
  weekPresencesCountList: WeekPresencesCountDto[]
}

export enum EPeriod {
  CurrentYear = 'current_year',
  LastYear = 'last_year',
}

export const getEPeriodList: Getter<EPeriod[]> = lazyLoad(() => Object.values(EPeriod))
